const ThemeOptions = {
  typography: {
    baseFontFamily: '"Roboto", sans-serif',
    baseFontSize: 16,
    baseBorderRadius: 4,
  },
  colors: {
    baseColor: '#333333',
    primaryColor: '#ffb545',
    borderColor: '#dfe1e4',
    spinnerRgbColor: '255 181 69',
  },
  components: {
    LayoutForm: {
      backgroundColor: '#fbf7f3',
      boxShadow: '0px 10px 20px rgba(73, 115, 120, 0.15)',
      borderRadius: 4,
    },
    LayoutComponentsWrapper: {
      label: {
        fontSize: 16,
        color: '#333',
        opacity: 0.6,
        '@media(min-width: 1024px)': {
          fontSize: 18,
        },
      },
    },
    OrderServiceType: {
      borderBottomWidth: 0,
      button: {
        fontFamily: '"Roboto", sans-serif',
        backgroundColor: 'white',
        fontSize: '17px !important',
        color: '#333',
        fontWeight: 400,
        letterSpacing: '0',
        borderRadius: 0,
        zIndex: 0,
        transition: 'background-color 0.3s ease, color 0.3s ease',
        ':first-child': {
          borderTopLeftRadius: 8,
        },
        ':last-child': {
          borderTopRightRadius: 8,
        },
        svg: {
          desktop: {
            display: 'none',
          },
        },
        active: {
          color: '#333',
          backgroundColor: '#fbf7f3',
          boxShadow: 'none',
          zIndex: 1,
        },
        hover: {
          color: '#333',
          backgroundColor: 'white',
        },
      },
    },
    TaskSize: {
      marginBottom: 20,
      '> div': {
        border: 'none',
      },
      button: {
        fontFamily: '"Roboto", sans-serif',
        fontSize: 16,
        border: 'none',
        borderRadius: 0,
        color: '#000000',
        '@media(min-width: 768px)': {
          fontSize: 18,
        },
      },
    },
    UIButton: {
      transition: 'background-color 0.3s ease, color 0.3s ease',
      color: '#333',
      borderRadius: 0,
      fontSize: 16,
      desktop: {
        fontSize: 18,
        lineHeight: '20px',
      },
      active: {
        color: '#333',
      },
      hover: {
        backgroundColor: '#ffb545',
        color: '#333',
      },
    },
    UISelect: {
      color: '#333',
      '&::after': {
        desktop: {
          borderWidth: '8px 6px 0',
          right: 15,
        },
      },
      select: {
        borderColor: 'transparent',
        fontSize: 18,
        paddingLeft: '17px !important',
        lineHeight: '20px',
        color: '#000000',
        desktop: {
          lineHeight: '20px',
          color: '#333',
          paddingRight: 30,
        },
      },
    },
    OrderButton: {
      backgroundColor: '#FFB545',
      color: '#333',
      fontSize: 18,
      padding: '12px 40px',
      borderRadius: 30,
      letterSpacing: 0,
      lineHeight: '1.45',
      fontWeight: 400,
      transition: 'background-color 0.3s ease, color 0.3s ease',
      textAlign: 'center',
      whiteSpace: 'nowrap',
      fondWeight: '500',
      desktop: {
        width: '15.5rem',
      },
      hover: {
        backgroundColor: '#ffcd4b',
        color: '#333',
        textDecoration: 'none',
      },
      strong: {
        fontSize: 30,
      },
    },
  },
};

export default ThemeOptions;
